var map = {
	"./Achievements/mech-paper.jpg": 2639,
	"./Achievements/niot.png": 2311,
	"./Achievements/robosub.jpg": 9487,
	"./Achievements/robosub2021.jpeg": 2015,
	"./Brochure.pdf": 9618,
	"./Competetions/niot.jpg": 1363,
	"./Competetions/robosub.jpg": 7635,
	"./Competetions/sauvc.jpg": 6497,
	"./DSC02829.jpg": 4499,
	"./HD-amazing-photo-underwater.jpg": 9931,
	"./Legacy/ANSHULNARWARIYA.jpg": 6383,
	"./Legacy/LikithSaijonna.jpg": 5798,
	"./Legacy/VarunMahajan.jpeg": 5843,
	"./Legacy/abhinav.jpeg": 6015,
	"./Legacy/abhinavarora.jpeg": 1117,
	"./Legacy/akash.jpg": 9916,
	"./Legacy/akashjain.jpeg": 2207,
	"./Legacy/akashkumar.jpeg": 2487,
	"./Legacy/harshitsinha.jpeg": 3753,
	"./Legacy/manishkumar.jpeg": 1061,
	"./Legacy/mayankmittal.jpeg": 6363,
	"./Legacy/mohit.jpg": 6667,
	"./Legacy/namanaggarwal.jpeg": 6456,
	"./Legacy/naveen.jpeg": 96,
	"./Legacy/nilay.jpeg": 1212,
	"./Legacy/rithvikpatibandla.jpeg": 348,
	"./Legacy/sakshammittal.jpeg": 3778,
	"./Legacy/shibhanshd.jpeg": 5687,
	"./Legacy/siddhartha.jpeg": 6733,
	"./Legacy/vikram.jpg": 1036,
	"./Legacy/yazurgupta.jpeg": 4745,
	"./NIOT.png": 6314,
	"./SnT Techkriti Poster redifined.png": 6033,
	"./anahita-1.jpg": 6154,
	"./anahita-2.jpg": 6645,
	"./anahita/AnahitaElec.jpg": 6248,
	"./anahita/AnahitaSoft.jpg": 4603,
	"./anahita/anahita-3.jpg": 2199,
	"./anahita/anahita-underwater.png": 1029,
	"./anahita/anahita-underwater2.png": 3744,
	"./anahita/anahita_exploded.png": 8841,
	"./anahita/battery.png": 5866,
	"./anahita/camera.png": 1080,
	"./anahita/conandpen.png": 4197,
	"./anahita/cv.png": 2470,
	"./anahita/frame.png": 5314,
	"./anahita/gabber.png": 240,
	"./anahita/header_06.png": 1353,
	"./anahita/hull.png": 8752,
	"./anahita/hydrophones.jfif": 6771,
	"./anahita/imu.png": 5642,
	"./anahita/markerdropper.png": 4319,
	"./anahita/mechmain.png": 3165,
	"./anahita/objdetection.png": 1441,
	"./anahita/pneumatic.png": 3983,
	"./anahita/powermgmt.png": 8337,
	"./anahita/sensors.png": 5292,
	"./anahita/torpedo.png": 2024,
	"./anahita_design.jpg": 6463,
	"./atal.png": 5260,
	"./atal/1.jpg": 6568,
	"./atal/CFD.jpeg": 9577,
	"./atal/Control Layer (1).png": 1539,
	"./atal/Control Layer.png": 9269,
	"./atal/F_YOLO.png": 7515,
	"./atal/Gazebo Simulation.png": 2962,
	"./atal/Navigation Layer (4).png": 4661,
	"./atal/Screenshot 2026-03-07 at 11.30.06 PM.png": 8895,
	"./atal/Screenshot 2026-03-07 at 11.30.35 PM.png": 1817,
	"./atal/Software_Architecture.png": 554,
	"./atal/Vision_Layer (1).png": 1613,
	"./atal/Yolo_V3.png": 6390,
	"./atal/after_preprocess.jpg": 4882,
	"./atal/atal.jpg": 6641,
	"./atal/atal2.jpg": 495,
	"./atal/atal2026.jpeg": 184,
	"./atal/atal_design.png": 6432,
	"./atal/atal_hull.jpeg": 2520,
	"./atal/atal_thruster.png": 7997,
	"./atal/before_preprocess.jpg": 763,
	"./atal/boost_render.png": 4397,
	"./atal/buck_render.png": 9657,
	"./atal/camera explode.PNG": 8208,
	"./atal/cfd.jpg": 1424,
	"./atal/connector.png": 6208,
	"./atal/electrical_architecture.jpg": 8713,
	"./atal/esc_render.png": 5345,
	"./atal/file_2024-11-10_18.16.12.png": 1105,
	"./atal/grabber_combined.png": 4004,
	"./atal/hull cap removed.JPG": 3579,
	"./atal/hull_final.png": 3893,
	"./atal/mcu_board.png": 8333,
	"./atal/md working2.PNG": 2388,
	"./atal/molex-micro-fit-connector.jpg": 3905,
	"./atal/newest render.PNG": 2501,
	"./atal/power_board.png": 1043,
	"./atal/pressure contour.jpg": 9578,
	"./atal/processing_combined.png": 5900,
	"./atal/stress profile across base.jpg": 9320,
	"./atal/torpedo compartments.PNG": 2878,
	"./atal/yolov11.jpg": 1772,
	"./atal_design.png": 6712,
	"./atwork.png": 9668,
	"./auv-logo-mini.png": 4218,
	"./auv-logo.png": 4640,
	"./backgrounds/bg-1.jpg": 8565,
	"./backgrounds/bg-2.jpg": 6490,
	"./backgrounds/drop-header.jpg": 1639,
	"./backgrounds/drop-header2.png": 6741,
	"./backgrounds/hdback.jpg": 5151,
	"./backgrounds/hdunderwater.jpg": 1,
	"./backgrounds/sea-header-2.jpg": 4942,
	"./backgrounds/triton-banner.png": 8561,
	"./backgrounds/triton-light.png": 4519,
	"./backgrounds/water-header.jpg": 671,
	"./blog/BlogImages/AfterStructuralAnalysis.jpg": 2299,
	"./blog/BlogImages/AfterTopologyOptimisation.jpg": 7351,
	"./blog/BlogImages/Anahita.jpg": 6536,
	"./blog/BlogImages/DragVsVelocity.png": 1346,
	"./blog/BlogImages/FinalFrame.png": 6683,
	"./blog/BlogImages/ROS.jpg": 4462,
	"./blog/BlogImages/SidePlateTopologyOptimization.jpg": 3945,
	"./blog/BlogImages/VelocityStreamlines.jpg": 2184,
	"./blog/BlogImages/background.png": 3848,
	"./blog/BlogImages/bot_orientation.jpg": 1886,
	"./blog/BlogImages/final_orientation.jpg": 4673,
	"./blog/BlogImages/hydrophone.jpeg": 7315,
	"./blog/BlogImages/hydrophones_page_1.jpeg": 9478,
	"./blog/BlogImages/hydrophones_page_2.jpeg": 5395,
	"./blog/BlogImages/hydrophones_page_3.jpeg": 92,
	"./blog/BlogImages/hydrophones_workflow.png": 7123,
	"./blog/BlogImages/i7.jpg": 2480,
	"./blog/background.png": 5517,
	"./blog/categories/Jekyll.png": 4117,
	"./blog/categories/ProcessorRobotics.png": 1743,
	"./blog/categories/ROS.png": 1392,
	"./blog/categories/Tutorials.png": 1273,
	"./blog/posts/7 Useful Tips for ROS Users/background.png": 9004,
	"./blog/posts/7 Useful Tips for ROS Users/copy-paste-meme.jpg": 3504,
	"./blog/posts/7 Useful Tips for ROS Users/node-manager.png": 4598,
	"./blog/posts/ANSYS helps AUV-IITK design its latest vehicle Anahita/AfterStructuralAnalysis.jpg": 89,
	"./blog/posts/ANSYS helps AUV-IITK design its latest vehicle Anahita/AfterTopologyOptimisation.jpg": 5266,
	"./blog/posts/ANSYS helps AUV-IITK design its latest vehicle Anahita/Anahita.jpg": 1717,
	"./blog/posts/ANSYS helps AUV-IITK design its latest vehicle Anahita/DragVsVelocity.png": 1849,
	"./blog/posts/ANSYS helps AUV-IITK design its latest vehicle Anahita/FinalFrame.png": 7032,
	"./blog/posts/ANSYS helps AUV-IITK design its latest vehicle Anahita/SidePlateTopologyOptimization.jpg": 5904,
	"./blog/posts/ANSYS helps AUV-IITK design its latest vehicle Anahita/VelocityStreamlines.jpg": 1445,
	"./blog/posts/ANSYS helps AUV-IITK design its latest vehicle Anahita/background.png": 9259,
	"./blog/posts/Do You Really Need An i7/background.png": 4792,
	"./blog/posts/Welcome to AUVeScope/background.png": 3438,
	"./business.jpg": 4198,
	"./businesstransparent.jpg": 2586,
	"./combined.jpg": 4837,
	"./competitions.jpg": 3620,
	"./csr.png": 8074,
	"./csr2025.jpeg": 528,
	"./designbot.png": 4020,
	"./download.png": 9352,
	"./electrical.jpeg": 1851,
	"./electrical.jpg": 7390,
	"./electricaltransparent.jpg": 5394,
	"./electronics.png": 1823,
	"./gear.jpg": 9929,
	"./image.png": 173,
	"./logo_iitk_actual.png": 9842,
	"./logos/auv_logo.png": 4213,
	"./logos/auv_logo2.png": 8531,
	"./logos/logo_v1.32.png": 2519,
	"./logos/our-client.jpg": 545,
	"./logos/whitelogo.png": 7017,
	"./mechanical.jpg": 9253,
	"./mechanicaltransparent.jpg": 8383,
	"./newreplaced.jpg": 2879,
	"./newteam.jpeg": 3028,
	"./niotwinner.jpeg": 1672,
	"./niotwinner.png": 4799,
	"./projects.jpg": 4634,
	"./research.jpeg": 4720,
	"./research.jpg": 4743,
	"./software.jpeg": 6996,
	"./software.jpg": 3707,
	"./softwaretransparent.jpg": 2509,
	"./sponsors/altium.png": 8318,
	"./sponsors/ansys.jpg": 7684,
	"./sponsors/dord-iitk.png": 6311,
	"./sponsors/ids.png": 1790,
	"./sponsors/mathworks.png": 2768,
	"./sponsors/solidworks.png": 4331,
	"./sponsors/sparton.png": 6195,
	"./sponsors/xsens.png": 613,
	"./tarang.jpg": 5207,
	"./tarang/Control Layer (1).png": 6572,
	"./tarang/Control Layer.png": 6586,
	"./tarang/F_YOLO.png": 9914,
	"./tarang/Gazebo Simulation.png": 6129,
	"./tarang/Navigation Layer (4).png": 6692,
	"./tarang/Software_Architecture.png": 9713,
	"./tarang/Tarang.png": 1523,
	"./tarang/Vision_Layer (1).png": 2548,
	"./tarang/Yolo_V3.png": 7333,
	"./tarang/after_preprocess.jpg": 1471,
	"./tarang/before_preprocess.jpg": 1368,
	"./tarang/boost_render.png": 7436,
	"./tarang/buck_render.png": 3410,
	"./tarang/camera explode.PNG": 7101,
	"./tarang/cfd.jpg": 9383,
	"./tarang/connector.png": 8399,
	"./tarang/electrical_architecture.jpg": 7406,
	"./tarang/esc_render.png": 42,
	"./tarang/grabber_combined.png": 3453,
	"./tarang/hull cap removed.JPG": 1246,
	"./tarang/hull_final.png": 8748,
	"./tarang/mcu_board.png": 1242,
	"./tarang/md working2.PNG": 911,
	"./tarang/molex-micro-fit-connector.jpg": 6810,
	"./tarang/power_board.png": 1004,
	"./tarang/pressure contour.jpg": 1147,
	"./tarang/processing_combined.png": 3831,
	"./tarang/stress profile across base.jpg": 2901,
	"./tarang/thruster placement.jpg": 4734,
	"./tarang/thruster placement2.JPG": 5899,
	"./tarang/torpedo compartments.PNG": 8639,
	"./tarang/yolov11.jpg": 1647,
	"./team-photo.jpg": 5192,
	"./team/ArnavPandey.jpg": 323,
	"./team/AyushAgrawal.jpeg": 7859,
	"./team/DakshitaMittal.jpg": 918,
	"./team/HiteshArunagiri.jpeg": 1568,
	"./team/JasjotSingh.jpg": 522,
	"./team/Krishna.jpg": 24,
	"./team/KushalSosale.jpg": 7869,
	"./team/MahavirAgarwal.jpg": 7121,
	"./team/SJ.jpg": 8335,
	"./team/SW.jpg": 9566,
	"./team/SanikaGumaste.jpeg": 412,
	"./team/SarathK.jpeg": 2005,
	"./team/ShivamSinghal.jpg": 8872,
	"./team/ShubhamKumar.jpg": 6838,
	"./team/Tanmaygrover.jpg": 825,
	"./team/VedantGitte.jpeg": 7308,
	"./team/aayushg.jpg": 2442,
	"./team/abhishek.jpeg": 4234,
	"./team/amank.jpg": 1032,
	"./team/aryanb.jpg": 3255,
	"./team/aryansh.jpg": 32,
	"./team/atharv.jpg": 718,
	"./team/author.jpg": 5861,
	"./team/ayush.jpg": 2612,
	"./team/chinmay.jpg": 8745,
	"./team/default.jpg": 4285,
	"./team/devabrata.jpg": 9592,
	"./team/devendra.jpg": 1919,
	"./team/dhruvmishra.jpeg": 9314,
	"./team/divyanshkankariya.jpg": 9439,
	"./team/indranilSaha.jpg": 5772,
	"./team/insert.jpg": 863,
	"./team/inshu.jpg": 5887,
	"./team/jaskeerat.jpg": 2882,
	"./team/jatinrastogi.jpg": 6229,
	"./team/jayant.jpeg": 4912,
	"./team/kamlesh.jpg": 4955,
	"./team/keshavc.jpg": 2573,
	"./team/lakshyab.jpg": 9431,
	"./team/mahavir.jpg": 5248,
	"./team/monika.jpg": 780,
	"./team/neelabh.jpg": 357,
	"./team/omjee.jpg": 9786,
	"./team/omkar.jpeg": 1605,
	"./team/omshivam.jpg": 7274,
	"./team/p.jpg": 5486,
	"./team/placeholder.png": 6825,
	"./team/prakhar.jpg": 2045,
	"./team/prateek.jpg": 5328,
	"./team/priank.jpg": 6889,
	"./team/priank2.jpg": 263,
	"./team/priyansh.jpg": 2032,
	"./team/ritam.jpeg": 2521,
	"./team/sahilbansal.jpeg": 3573,
	"./team/saivedant.jpeg": 508,
	"./team/sanyamjain.jpeg": 1852,
	"./team/shashank.jpeg": 6850,
	"./team/shashikant.png": 8638,
	"./team/shivamsharma.jpg": 1908,
	"./team/shivangpandey.jpeg": 7736,
	"./team/shubham-korde.jpg": 7097,
	"./team/sumay.jpg": 3138,
	"./team/sumithooda.jpg": 7237,
	"./team/tanishq.jpg": 4162,
	"./team/tarungoyal.jpg": 3896,
	"./team/tejasgupta.jpg": 3854,
	"./team_2025.zip": 1618,
	"./team_2025/Aarzoo.jpg": 7034,
	"./team_2025/AiklavyaveerSinghRana.jpeg": 9614,
	"./team_2025/ArnavGupta.jpeg": 9360,
	"./team_2025/ArushiKondaskar.jpeg": 119,
	"./team_2025/AryamanOberoi.png": 6515,
	"./team_2025/AshishUpadhyay.jpg": 1881,
	"./team_2025/AyushMuttepawar.jpg": 950,
	"./team_2025/DhakshithS.jpg": 8011,
	"./team_2025/DhruvKejriwal.png": 4444,
	"./team_2025/Dipak-Kumar-Giri.jpg": 3488,
	"./team_2025/Gaurigupta.jpg": 8701,
	"./team_2025/Hamza.jpg": 2689,
	"./team_2025/HarshaMarri.png": 4996,
	"./team_2025/IraSrivastava.jpg": 1386,
	"./team_2025/JeetrajGupta.jpg": 1714,
	"./team_2025/KhushalWadhwa.jpeg": 9309,
	"./team_2025/LikithSaijonna.jpg": 1538,
	"./team_2025/MeetSolanki.jpg": 9540,
	"./team_2025/PrakharJain.jpg": 1633,
	"./team_2025/PrathameshKukade.jpg": 5416,
	"./team_2025/RaghavDangayach.jpg": 7691,
	"./team_2025/RudreshThakur.jpg": 6958,
	"./team_2025/SUYASHKUMAR.jpg": 5145,
	"./team_2025/SaiShreyas.png": 8530,
	"./team_2025/SaketNandedkar.jpeg": 1195,
	"./team_2025/SaketNandedkar.jpg": 4702,
	"./team_2025/SamridhiJain.jpeg": 1352,
	"./team_2025/SauravKumar.jpg": 5400,
	"./team_2025/ShrutiSahu.jpg": 7772,
	"./team_2025/SparshJain.jpg": 7317,
	"./team_2025/SreejaSrinivasan.jpeg": 2195,
	"./team_2025/SunidhiChauhan.png": 1057,
	"./team_2025/aarzooalt.jpg": 9757,
	"./team_2025/harikrishna.jpg": 8392,
	"./team_2025/ishwinKumar.jpg": 6574,
	"./team_2025/vishnu.jpeg": 9408,
	"./training.jpg": 6466,
	"./training.png": 1510,
	"./training2025.png": 9307,
	"./trophy-icon.png": 7618,
	"./underwater-anahita.png": 8602,
	"./underwaterbackground.jpeg": 256,
	"./uriel-soberanes.jpg": 5827,
	"./uwback.jpg": 3109,
	"./varun.jpg": 9187,
	"./varun/VARUN-AUV/AnsysFluidSimulation.png": 4044,
	"./varun/VARUN-AUV/ArduinoAtmega.png": 8124,
	"./varun/VARUN-AUV/BatteryManagement.png": 2479,
	"./varun/VARUN-AUV/CentralHull.png": 8027,
	"./varun/VARUN-AUV/ConnectorAssembly.png": 1288,
	"./varun/VARUN-AUV/FrontCameraCasing.png": 7040,
	"./varun/VARUN-AUV/HullInternalTray.png": 6323,
	"./varun/VARUN-AUV/LogiTechCamera.png": 3635,
	"./varun/VARUN-AUV/LowerCameraCasing.png": 9858,
	"./varun/VARUN-AUV/MechanicalStructure.png": 6557,
	"./varun/VARUN-AUV/MotorDrivers.png": 5989,
	"./varun/VARUN-AUV/NavStickIMU.png": 9729,
	"./varun/VARUN-AUV/OdroidX2.png": 4216,
	"./varun/VARUN-AUV/OrthogonalProjectionsVarun.png": 3576,
	"./varun/VARUN-AUV/PWMvsThrustGraph.png": 5852,
	"./varun/VARUN-AUV/PneumaticAssembly.png": 4831,
	"./varun/VARUN-AUV/PressureSensorUS381.png": 1374,
	"./varun/VARUN-AUV/PressureVariationAnsys.png": 8609,
	"./varun/VARUN-AUV/ROSArchitecture.png": 6608,
	"./varun/VARUN-AUV/SeaBotixThrusters.png": 8054,
	"./varun/VARUN-AUV/SidePlateDesign.png": 4200,
	"./varun/VARUN-AUV/SoftwareFrameworks.png": 3217,
	"./varun/VARUN-AUV/StressAnalysisOnAnsys.png": 454,
	"./varun/VARUN-AUV/TiberiusGuerillaPaintballTank.png": 3816,
	"./varun/VARUN-AUV/Torpedo.png": 2156,
	"./varun/VARUN-AUV/VarunFrame.png": 2888,
	"./varun/VARUN-AUV/VisionAlgorithm.png": 1666,
	"./varun/VARUN-AUV/camcase.JPG": 1563,
	"./varun/VARUN-AUV/designops.png": 2175,
	"./varun/VARUN-AUV/framecombined.JPG": 2496,
	"./varun/VARUN-AUV/pnematic.png": 5698,
	"./varun/VARUN-AUV/rqtgraph.png": 1754,
	"./varun/software.png": 4574,
	"./varun/software_logos.png": 3292,
	"./varun/varun-underwater.jpg": 6897,
	"./varun/varun_exploded.png": 7781,
	"./varun/varun_labelled.png": 4529,
	"./varun/varun_power.png": 2853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;